<template>
	<div class="app">
		<div class="frame_top">
			<!-- 网页头部导航 开始-->
			<div class="head">
				<div class="headWap">
					<a href="/"><img src="/images/logo.png" class="logo"/></a>  
					<div v-if="userinfo" class="userInfo">
						<img src="/images/user.png" class="userImg"/>
						<div class="userWap">
							<p>{{userinfo.username}}</p>
							<ul>
								<li><a class="accoutBtn" @click="showzhanghu">我的账户</a></li>
								<li><a class="tracksBtn" @click="showzuji">我的足迹</a></li>
								<li><a class="collectionBtn" @click="showshoucang">我的收藏</a></li>
								<li><a class="messageBtn" @click="showzixunjianyi">咨询建议</a></li>
								<li><a id="logout" @click="logoutfnc">退出</a></li>
							</ul>
						</div>
					</div>
					<input v-else @click="checkLoginStatus" type="button" value="登录" class="login"/>
					<div class="searchBtn" v-if="$route.name!='search'" @click="showSearchPanel()">Search<i></i></div>
					<div class="searchPop" v-show="showhistroyflag">
						<div class="search">
							<input type="text" placeholder="Search" id="searchInput" ref="searchinput" v-model="keyword" @focus="showsug" @keyup="showsug" @blur="hidesug" @keypress.enter="jumpSearch" />
							
							<i id="searchEmpty" v-show="keyword" @click="clearword"></i>
							<input type="button" @click="searchBtnJump"/>
						</div>
						<div class="search_dropdown" v-show="showsugflag" style="">
							<ul class="hotkeywords">
								<li v-for="(item,index) in sugwordsList" @mousedown="selhistory(item,0)" style="margin-left: 0px;">
									<btn v-html="item.replace(cachekeyword,'<span style=\'font-weight:bold;\'>'+cachekeyword+'</span>')"></btn>
								</li>
							</ul>
						</div>
						<div v-show="!showsugflag" class="history">
							<input type="button" @mousedown.prevent="removehistoryall" class="del" value="清空全部"/>
							<p>检索历史</p>
							<div class="clearfix"></div>
							<ul>
								<li v-for="(item,index) in keyhistory">
									<span style="cursor: pointer;" @mousedown.prevent="selhistory(item,1)">{{item}}</span>
									<i @mousedown.prevent="removehistory(item)"></i>
								</li>
							</ul>
						</div>
						<div v-show="!showsugflag" class="hotWord">
							<p>检索热词</p>
							<ul>
								<li v-for="(item,index) in hotwords" @mousedown.prevent="selhistory(item,2)">
									{{item}}
								</li>
							</ul>
						</div>
					</div>
					<div class="searchBg" v-show="showhistroyflag"  @click="hideSearchPanel()"></div>
					<div class="itemTop">
						<router-link to="/" exact-active-class="active" @click.native="trackMenuClick('首页')">首页</router-link>
						<router-link to="/toutiao" exact-active-class="active" @click.native="trackMenuClick('头条')">头条</router-link>
						<router-link to="/huanqiu" exact-active-class="active" @click.native="trackMenuClick('寰球')">寰球</router-link>
						<router-link to="/jishu" exact-active-class="active" @click.native="trackMenuClick('技术')">技术</router-link>
						<router-link to="/guandian" exact-active-class="active" @click.native="trackMenuClick('观点')">观点</router-link>
						<router-link to="/baogao" exact-active-class="active" @click.native="trackMenuClick('报告')">报告</router-link>
						<router-link to="/yuntu" active-class="active" @click.native="trackMenuClick('数据')">数据</router-link>
						<router-link to="/shijian" exact-active-class="active" @click.native="trackMenuClick('实践')">实践</router-link>
						<router-link to="/zhengce" exact-active-class="active" @click.native="trackMenuClick('政策')">政策</router-link>
					</div>
					<div class="itemBottom">
						<router-link to="/ztshuzijichusheshi" exact-active-class="active" @click.native="trackMenuClick('数字基础设施')">数字基础设施</router-link>
						<router-link to="/ztshujuziyuan" exact-active-class="active" @click.native="trackMenuClick('数据资源')">数据资源</router-link>
						<a>
							数字经济
							<img src="/images/down.png" style="margin: 0px 0px 4px 8px;" />
							<div class="subItemBottom">
								<router-link to="/ztgongyehulianwang" exact-active-class="active" @click.native="trackMenuClick('工业互联网')">工业互联网<i></i></router-link>
								<router-link to="/ztzhihuinongye" exact-active-class="active" @click.native="trackMenuClick('智慧农业')">智慧农业<i></i></router-link>
								<router-link to="/ztzhihuiwuliu" exact-active-class="active" @click.native="trackMenuClick('智慧交通')">智慧交通<i></i></router-link>
								<router-link to="/ztshuzijinrong" exact-active-class="active" @click.native="trackMenuClick('数字金融')">数字金融<i></i></router-link>
								<router-link to="/ztrengongzhineng" exact-active-class="active" @click.native="trackMenuClick('人工智能')">人工智能<i></i></router-link>
								<router-link to="/ztdianzishangwu" exact-active-class="active" @click.native="trackMenuClick('电子商务')">电子商务<i></i></router-link>
								<router-link to="/ztdashuju" exact-active-class="active" @click.native="trackMenuClick('大数据')">大数据<i></i></router-link>
								<router-link to="/ztyunjisuan" exact-active-class="active" @click.native="trackMenuClick('云计算')">云计算<i></i></router-link>
								<router-link to="/ztwulianwang" exact-active-class="active" @click.native="trackMenuClick('物联网')">物联网<i></i></router-link>
							</div>
						</a>
						<router-link to="/ztshuzizhengwu" exact-active-class="active" @click.native="trackMenuClick('数字政务')">数字政务</router-link>
						<router-link to="/ztshuziwenhua" exact-active-class="active" @click.native="trackMenuClick('数字文化')">数字文化</router-link>
						<a>
							数字社会
							<img src="/images/down.png" style="margin: 0px 0px 4px 8px;" />
							<div class="subItemBottom">
								<router-link to="/ztzhihuijiaoyu" exact-active-class="active" @click.native="trackMenuClick('智慧教育')">智慧教育<i></i></router-link>
								<router-link to="/ztzhihuiyiliao" exact-active-class="active" @click.native="trackMenuClick('智慧医疗')">智慧医疗<i></i></router-link>
								<router-link to="/ztshuzixiangcun" exact-active-class="active" @click.native="trackMenuClick('数字乡村')">数字乡村<i></i></router-link>
								<router-link to="/ztzhihuichengshi" exact-active-class="active" @click.native="trackMenuClick('智慧城市')">智慧城市<i></i></router-link>
							</div>
						</a>
						<router-link to="/ztshuzishengtaiwenming" exact-active-class="active" @click.native="trackMenuClick('数字生态文明')">数字生态文明</router-link>
						
						
						<!-- <router-link to="/ztshuzimaoyi" exact-active-class="active">数字贸易</router-link> -->
					</div>
					<div class="itemBottom">
						<router-link to="/ztshuzichuangxintixi" exact-active-class="active" @click.native="trackMenuClick('数字创新体系')">数字创新体系</router-link>
						<router-link to="/ztshuzianquan" exact-active-class="active" @click.native="trackMenuClick('数字安全')">数字安全</router-link>
						<router-link to="/ztshuzizhili" exact-active-class="active" @click.native="trackMenuClick('数字治理')">数字治理</router-link>
						<router-link to="/ztguojihezuo" exact-active-class="active" @click.native="trackMenuClick('国际合作')">国际合作</router-link>
					</div>
				</div>
			</div>
			<!-- 网页头部导航 结束-->

			<router-view @showLogin="showLogin" @showzixunjianyifromsearch="showzixunjianyifromsearch" />
		</div>
		<appfooter></appfooter>
		
		<!-- 右侧菜单 开始-->
		<div class="rightBar">
		  <ul>
		    <li @click="showzhanghu"><span class="accoutBtn"><i>我的账户</i><img src="/images/rightIcon01.png"/></span></li>
		    <li @click="showzuji"><span class="tracksBtn"><i>我的足迹</i><img src="/images/rightIcon02.png"/></span></li>
		    <li @click="showshoucang"><span class="collectionBtn"><i>我的收藏</i><img src="/images/rightIcon03.png"/></span></li>
		    <li @click="showzixunjianyi"><span class="messageBtn"><i>咨询建议</i><img src="/images/rightIcon04.png"/></span></li>
		    <li>
		      <span><i>二维码</i><img src="/images/rightIcon05.png"/></span>
		      <div class="code">
		        <img src="/images/ma_gzh.jpg" width="88px" height="88px"/>
		        <p>公众号</p>
		        <img src="/images/ma_xcx.jpg" width="88px" height="88px"/>
		        <p>小程序</p>
		      </div>
		    </li>
		  </ul>
		</div>
		<div id="back-to-top"><a href="#top"><span></span><i></i></a></div>
		<!-- 右侧菜单 结束-->
		
		<div class='fixed_floating2' v-show="limitAdBannerVisible">
			<div class='fixed_floating2-box'>
					<a  class='a a-myaccount '  name='D_account' href="/activity" target="_blank"><img src="/images/downloadad.png"></a>
					<a @click="limitAdBannerVisible=false" style="width: 100%;display: inline-block;text-align: center;font-size: 13px;">X关闭</a>
			</div>
		</div>
		<div class='fixed_floating2' v-show="adBannerVisible">
			<div class='fixed_floating2-box'>
				  <!-- <img @click="adBannerVisible=false" src="/images/icon_close.png" style="position: absolute;right: 0px;top: 0px;"> -->
					<a  class='a a-myaccount '  name='D_account' @click="showDownloadDialog"><img src="/images/downloadad.png"></a>
					<!-- <a  class='a a-myaccount '  name='D_account' href="https://dei.cei.cn/" target="_blank"><img src="/images/downloadad-bak.png"></a> -->
					<a @click="adBannerVisible=false" style="width: 100%;display: inline-block;text-align: center;font-size: 13px;">X关闭</a>
			</div>
		</div>
		
		<keep-alive>
			<floatlogin v-if="dialogLoginVisible"  @closefloat="closelogin"></floatlogin>
		</keep-alive>
		
		<el-dialog class="dialogAD" :visible.sync="dialogADVisible" :close-on-click-modal="true" :close-on-press-escape="false" width="1107px" >
		  <floatad></floatad>
		</el-dialog>
		
		<floatzhanghu ref="zhanghuhandle" v-if="zhanghuVisible" v-bind:userinfo="userinfo" @closefloat="closezhanghu"
		 @showbangding="showbangding" @showquxiao="showquxiao" @showyanqi="showyanqi" v-bind:isdetailopen="bangdingVisible||quxiaoVisible||yanqiVisible"></floatzhanghu>
		 <floatbangding v-if="bangdingVisible" v-bind:userinfo="userinfo" @closefloat="closebangding"></floatbangding>
		 <floatquxiao v-if="quxiaoVisible" v-bind:userinfo="userinfo" @closefloat="closequxiao"></floatquxiao>
		 <floatyanqi v-if="yanqiVisible" v-bind:userinfo="userinfo" @closefloat="closeyanqi"></floatyanqi>
		<floatzuji v-if="zujiVisible" v-bind:userinfo="userinfo" @closefloat="closezuji"></floatzuji>
		<floatdingyue v-if="dingyueVisible" v-bind:userinfo="userinfo" @closefloat="closedingyue"></floatdingyue>
		<floatshoucang v-if="shoucangVisible" v-bind:userinfo="userinfo" @closefloat="closeshoucang"></floatshoucang>
		<floatzixunjianyi ref="zxjyhandle" v-if="zixunjianyiVisible" v-bind:userinfo="userinfo" @closefloat="closezixunjianyi"
		 @showzixun="showzixun" @showjianyi="showjianyi" v-bind:isdetailopen="zixunVisible||jianyiVisible" v-bind:showcolum="zixunjianyiColum" ></floatzixunjianyi>
		<floatzixun v-if="zixunVisible" v-bind:detailid="zixunid" @closefloat="closezixun"></floatzixun>
		<floatjianyi v-if="jianyiVisible" v-bind:detailid="jianyiid" @closefloat="closejianyi"></floatjianyi>
		
		<el-dialog :visible.sync="dialogDownloadVisible" title="会议回放资料" :close-on-click-modal="true" :close-on-press-escape="false" width="1000px" center>
		  <floatdownload @closefloat="closedownload"></floatdownload>
		</el-dialog>
		
		<iframe :src="exiturl" style="height:0px;display:none;" height="0"></iframe>
		
	</div>
</template>

<script>
	import appfooter from '@/components/footer.vue'
	import floatlogin from '@/components/home-login.vue'
	import floatzhanghu from '@/components/float-zhanghu.vue'
	import floatzuji from '@/components/float-zuji.vue'
	import floatshoucang from '@/components/float-shoucang.vue'
	import floatzixunjianyi from '@/components/float-zixunjianyi.vue'
	import floatzixun from '@/components/float-zixunjianyi-zixun.vue'
	import floatjianyi from '@/components/float-zixunjianyi-jianyi.vue'
	import floatbangding from '@/components/float-zhanghu-bangding.vue'
	import floatquxiao from '@/components/float-zhanghu-quxiao.vue'
	import floatyanqi from '@/components/float-zhanghu-yanqi.vue'
	import floatad from '@/components/home-ad.vue'
	import floatdownload from '@/components/home-download.vue'
	export default {
		data() {
			return{
				dialogADVisible:false,
				dialogDownloadVisible:false,
				dialogLoginVisible:false,
				userinfo:'',
				exiturl:'',
				keyword:'',
				zhanghuVisible:false,
				zujiVisible:false,
				dingyueVisible:false,
				shoucangVisible:false,
				zixunjianyiVisible:false,
				zixunjianyiColum:0,
				zixunVisible:false,
				zixunid:'',
				jianyiVisible:false,
				jianyiid:'',
				shiyongVisible:false,
				bangdingVisible:false,
				quxiaoVisible:false,
				yanqiVisible:false,
				
				showsugflag: false,
				sugdelaytimer:'',
				sugstaytimer:'',
				sugwordsList:[],
				showhistroyflag: false,
				keyhistory: [],
				hotwords: [],
				cachekeyword: '',
				
				zhuantiSubmenuVisible:false,
				
				adBannerVisible:false,
				limitAdBannerVisible:false,
			}
		},
		components:{
			appfooter,
			floatlogin,
			floatzhanghu,
			floatzuji,
			floatshoucang,
			floatzixunjianyi,
			floatzixun,
			floatjianyi,
			floatbangding,
			floatquxiao,
			floatyanqi,
			floatad,
			floatdownload
		},
		created:function(){
			this.getusernamefnc();
		},
		mounted:function(){
			this.checkIsNeedADBanner();
			this.checkIsNeedADDialog();
			this.checkIsNeedLoginDialog();
		},
		methods: {
			trackMenuClick:function(type){
				this.$track([
					['pagetype','导航栏-'+type+'-点击'],
				]);
			},
			trackClick:function(type){
				this.$track([
					['pagetype',type],
				]);
			},
			showDownloadDialog:function(){
				if(!this.$cookies.get('userinfo')){
					this.showLogin();
					return false;
				}
				else{
					this.dialogDownloadVisible=true;
				}
			},
			closedownload:function(){
				this.dialogDownloadVisible=false;
			},
			checkIsNeedADBanner:function(){
				if(new Date<new Date('2024/05/23 17:30:00')){
					this.adBannerVisible=false;
					this.limitAdBannerVisible=true;
				}
				else{
					this.adBannerVisible=false;
					this.limitAdBannerVisible=false;
				}
			},
			checkIsNeedADDialog:function(){
				if((!this.$cookies.get('adshowed'))&&(new Date<new Date('2024/05/23 17:30:00'))){
					this.dialogADVisible=true;
					this.$cookies.set('adshowed','1','12h');
				}
			},
			checkIsNeedLoginDialog:function(){
				if(this.$cookies.get('unlogin')){
					this.showLogin()
					this.$cookies.remove('unlogin');
				}
			},
			getusernamefnc: function() {
				let _this = this;
				this.$http({
						method: 'get',
						url: 'getUserName',
						responseType: 'json',
						params: {
							
						},
					})
					.then(function(response) {
						if(response.data&&response.data.data.data){
							_this.userinfo=response.data.data.data;
							_this.$cookies.set('userinfo',_this.userinfo);
							if(_this.$cookies.get('fromdetail')){
								var detailhref=_this.$cookies.get('fromdetail');
								_this.$cookies.remove('fromdetail');
								window.location.href=detailhref;
							}
						}
						else{
							_this.$cookies.remove('userinfo');
							_this.userinfo='';
						}
						
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			getuserinfofnc: function() {
				let _this = this;
				this.$http({
						method: 'get',
						url: 'UserInfo/getUserInfo',
						responseType: 'json',
						params: {
							
						},
					})
					.then(function(response) {
						// debugger;
						var tempinfo={
							userAccountID:response.data.data.data.userAccountID,
							username:response.data.data.data.username,
							usertype:response.data.data.data.usertype,
							outUrl:response.data.data.data.outUrl
						}
						_this.userinfo=tempinfo;
						_this.$cookies.set('userinfo',tempinfo);
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			checkLoginStatus:function(){
				this.$track([
					['pagetype','导航栏-登录按钮-点击'],
				]);
				let _this = this;
				this.$http({
						method: 'get',
						url: 'getUserName',
						responseType: 'json',
						params: {
							
						},
					})
					.then(function(response) {
						if(response.data&&response.data.data.data){
							_this.userinfo=response.data.data.data;
							_this.$cookies.set('userinfo',_this.userinfo);
						}
						else{
							_this.$cookies.remove('userinfo');
							_this.userinfo='';
							_this.showLogin();
						}
						
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			showLogin:function(){
				this.dialogLoginVisible=true;
				this.$track([
					['pagetype','登录页-浏览'],
				]);
				document.getElementsByTagName('body')[0].style.overflowY='hidden';
			},
			closelogin:function(){
				this.dialogLoginVisible=false;
				document.getElementsByTagName('body')[0].style.overflowY='auto';
			},
			showSearchPanel:function(){
				this.$track([
					['pagetype','导航栏-检索按钮-点击'],
				]);
				if(!this.$cookies.get('userinfo')){
					this.showLogin();
					return false;
				}
				this.keyhistory = this.$cookies.get('keyhistory') ? this.$cookies.get('keyhistory').split(',') : [];
				this.cachekeyword='';
				this.showsugflag = false;
				this.showhistroyflag = true;
				this.gethotwordfnc();
			},
			hideSearchPanel:function(){
				this.showsugflag = false;
				this.showhistroyflag = false;
			},
			clearword: function() {
				this.keyword = '';
				this.cachekeyword='';
				this.showsugflag = false;
			},
			showsug: function() {
				if (this.keyword) {
					if(this.cachekeyword!=this.keyword){
						this.getsugfnc();
					}
					this.showsugflag = true;
				} else {
					this.cachekeyword='';
					this.showsugflag = false;
				}
			},
			hidesug: function() {
				this.showsugflag = false;
			},
			removehistory: function(key) {
				var temphistorylist = this.$cookies.get('keyhistory') ? this.$cookies.get('keyhistory').split(',') : [];
				if (temphistorylist.indexOf(key) > -1) {
					temphistorylist.splice(temphistorylist.indexOf(key), 1);
					this.keyhistory = temphistorylist;
					this.$cookies.set('keyhistory', temphistorylist.toString(),'30d');
				}
			},
			removehistoryall: function() {
				this.keyhistory = '';
				this.$cookies.remove('keyhistory');
			},
			selhistory: function(key,type) {
				if(type==0){
					this.$track([
						['pagetype','导航栏-检索页-推荐关联词-关键词:'+key+'-点击'],
					]);
				}
				else if(type==1){
					this.$track([
						['pagetype','导航栏-检索页-检索历史-关键词:'+key+'-点击'],
					]);
				}
				else if(type==2){
					this.$track([
						['pagetype','导航栏-检索页-检索热词-关键词:'+key+'-点击'],
					]);
				}
				this.keyword = key;
				this.jumpSearch();
			},
			searchBtnJump:function(){
				this.$track([
					['pagetype','导航栏-检索页-检索栏-关键词:'+this.keyword+'-点击'],
				]);
				this.jumpSearch();
			},
			getsugfnc: function() {
				if (this.keyword) {
					let _this = this;
					this.cachekeyword=this.keyword;
					this.$http({
							method: 'get',
							url: 'SearchInfo/SugHotWordListInfo',
							responseType: 'json',
							params: {
								sugKey: this.keyword,
							},
						})
						.then(function(response) {
							_this.sugwordsList = response.data.data.data;
							clearTimeout(_this.sugstaytimer);
							_this.sugstaytimer = setTimeout(function (){
								if(_this.showsugflag&&_this.sugwordsList.length>0){
									_this.$track([
										['pagetype','sug提示'],
										['searchkeyword',_this.sugwordsList.join(' ')]
									]);
								}
							}, 2000);
							if(_this.sugwordsList.length<1){
								_this.showsugflag = false;
							}
						})
						.catch(function(error) {
							console.log(error);
						});
				}
			},
			gethotwordfnc: function() {
				let _this = this;
				this.$http({
						method: 'get',
						url: 'SearchInfo/SearchWordsListInfo',
						responseType: 'json',
						params: {
						},
					})
					.then(function(response) {
						_this.hotwords = response.data.data.data;
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			jumpSearch: function() {
				if(!this.$cookies.get('userinfo')){
					this.showLogin();
					return false;
				}
				// this.$router.push('/search'+(this.keyword?('/'+this.keyword):''));
				// window.open('/search'+(this.keyword?('/'+this.keyword):''), '_blank');
				this.$refs.searchinput.blur();
				this.hideSearchPanel();
				// this.hidesug();
				var a = document.createElement('a');
				a.setAttribute('href', '/search'+(this.keyword?('/'+encodeURIComponent(this.keyword)):''));
				a.setAttribute('style', 'display:none');  
				a.setAttribute('target', '_blank');  
				document.body.appendChild(a);
				a.click();
				a.parentNode.removeChild(a);  
				this.keyword='';
			},
			logoutfnc:function(){
				let _this = this;
				this.$http({
						method: 'get',
						url: 'UserInfo/out',
						responseType: 'json',
						params: {
							
						},
					})
					.then(function(response) {
						debugger
						if(response.data.code==20000){
							var tempoutUrl=_this.$cookies.get('userinfo').outUrl;
							_this.$cookies.remove('userinfo');
							_this.$cookies.remove('autologintoken');
							_this.exiturl=tempoutUrl;
							// _this.$alert('已退出登录', '提示信息', {
							// 	confirmButtonText: '确定',
							// 	callback: function(action) {
							// 		window.location.href='/';
							// 	}
							// });
							
							// var iframe1 = document.getElementById('exit');
							// if (-1 == navigator.userAgent.indexOf("MSIE")) {
							// 		iframe1.src = tempoutUrl;
							// } else {
							// 		iframe1.location = tempoutUrl;
							// }
							
							// window.location.href=tempoutUrl;
							//统一认证退出链接,appid为新专网id
							// window.location.href='https://passport.cei.cn/Action/DoView.ashx?view=exit&appid=10011018';
						}
						else{
							_this.$message({
								message: '退出失败，请重试',
								type: 'warning'
							});
						}
						
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			showzhanghu:function(){
				if(!this.userinfo){
					this.$message({
						message: '对不起，该功能仅提供给注册用户',
						type: 'warning'
					});
					
					return false;
				}
				this.trackClick('侧边栏-我的账户-点击');
				this.zhanghuVisible=true;
				document.getElementsByTagName('body')[0].style.overflowY='hidden';
			},
			closezhanghu:function(){
				this.getusernamefnc();
				this.zhanghuVisible=false;
				document.getElementsByTagName('body')[0].style.overflowY='auto';
			},
			showzuji:function(){
				if(!this.userinfo){
					this.$message({
						message: '对不起，该功能仅提供给注册用户',
						type: 'warning'
					});
					
					return false;
				}
				this.trackClick('侧边栏-我的足迹-点击');
				this.zujiVisible=true;
				document.getElementsByTagName('body')[0].style.overflowY='hidden';
			},
			closezuji:function(){
				this.zujiVisible=false;
				document.getElementsByTagName('body')[0].style.overflowY='auto';
			},
			showdingyue:function(){
				if(!this.userinfo){
					this.$message({
						message: '对不起，该功能仅提供给注册用户',
						type: 'warning'
					});
					
					return false;
				}
				this.dingyueVisible=true;
				document.getElementsByTagName('body')[0].style.overflowY='hidden';
			},
			closedingyue:function(){
				this.dingyueVisible=false;
				document.getElementsByTagName('body')[0].style.overflowY='auto';
			},
			showshoucang:function(){
				if(!this.userinfo){
					this.$message({
						message: '对不起，该功能仅提供给注册用户',
						type: 'warning'
					});
					
					return false;
				}
				this.trackClick('侧边栏-我的收藏-点击');
				this.shoucangVisible=true;
				document.getElementsByTagName('body')[0].style.overflowY='hidden';
			},
			closeshoucang:function(){
				this.shoucangVisible=false;
				document.getElementsByTagName('body')[0].style.overflowY='auto';
			},
			showzixunjianyi:function(){
				if(!this.userinfo){
					this.$message({
						message: '对不起，该功能仅提供给注册用户',
						type: 'warning'
					});
					
					return false;
				}
				this.trackClick('侧边栏-咨询建议-点击');
				this.zixunjianyiVisible=true;
				document.getElementsByTagName('body')[0].style.overflowY='hidden';
			},
			closezixunjianyi:function(){
				this.zixunjianyiVisible=false;
				document.getElementsByTagName('body')[0].style.overflowY='auto';
			},
			showzixunjianyifromsearch:function(){
				if(!this.userinfo){
					this.$message({
						message: '对不起，该功能仅提供给注册用户',
						type: 'warning'
					});
					
					return false;
				}
				this.zixunjianyiColum=1;
				this.zixunjianyiVisible=true;
				document.getElementsByTagName('body')[0].style.overflowY='hidden';
			},
			showzixun:function(id){
				this.zixunid=id;
				this.zixunVisible=true;
			},
			closezixun:function(){
				this.zixunVisible=false;
				this.$refs.zxjyhandle.getZixunListfnc();
			},
			showjianyi:function(id){
				this.jianyiid=id;
				this.jianyiVisible=true;
			},
			closejianyi:function(){
				this.jianyiVisible=false;
				this.$refs.zxjyhandle.getFankuiListfnc();
			},
			showshiyong:function(){
				// if(this.userinfo){
				// 	this.$message({
				// 		message: '该功能仅提供给非注册用户，您已登录，请继续使用',
				// 		type: 'warning'
				// 	});
					
				// 	return false;
				// }
				this.shiyongVisible=true;
				document.getElementsByTagName('body')[0].style.overflowY='hidden';
			},
			closeshiyong:function(){
				this.shiyongVisible=false;
				document.getElementsByTagName('body')[0].style.overflowY='auto';
			},
			showbangding:function(){
				this.bangdingVisible=true;
			},
			closebangding:function(){
				this.bangdingVisible=false;
				this.$refs.zhanghuhandle.getuserinfofnc();
			},
			showquxiao:function(){
				this.quxiaoVisible=true;
			},
			closequxiao:function(){
				this.quxiaoVisible=false;
				this.$refs.zhanghuhandle.getuserinfofnc();
			},
			showyanqi:function(){
				this.yanqiVisible=true;
			},
			closeyanqi:function(){
				this.yanqiVisible=false;
				this.$refs.zhanghuhandle.getuserinfofnc();
			},
		}
	}
</script>

<style>
	
</style>
